module.exports = __webpack_public_path__ + "static/media/calendar.e07659f4.svg";